import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    height: 30,
    minHeight: 30,
  },
  leftSpacer: {
    minWidth: '50%',
    height: '100%',
    borderRight: '2px inset rgb(128, 128, 128, 1)',
  },
  leftSpacerNoBorder: {
    minWidth: '50%',
    height: '100%',
  },
  leftSpacerFullHeight: {
    minWidth: '50%',
    height: '100%',
    borderRight: '2px inset rgb(128, 128, 128, 1)',
  },
}));

const TableCellVertLine = ({ hideLine, emptyLine }) => {
  const classes = useStyles();
  let className = '';
  if (hideLine) {
    className = classes.leftSpacerNoBorder;
  } else if (emptyLine) {
    className = classes.leftSpacerFullHeight;
  } else {
    className = classes.leftSpacer;
  }
  return (
    <Grid container item direction="row" alignItems="center" justifyContent="center" className={classes.root}>
      <Grid item className={className}></Grid>
      <Grid item style={{ minWidth: '50%', height: '100%' }}></Grid>
    </Grid>
  );
};

TableCellVertLine.propTypes = {
  hideLine: PropTypes.bool,
  emptyLine: PropTypes.bool,
};

TableCellVertLine.defaultProps = {
  hideLine: false,
  emptyLine: false,
};

export default TableCellVertLine;
